import ACTIONS, { FETCH_STATUS } from '../app.constants';
import { FilterCondition, Form } from '../modules/application/types';
import { LimitAndSkipData } from '../modules/inbox/types';
import { InboxCountType, InboxList, UpdateInboxStatus } from '../modules/inbox/types';
export const getInbox = {
    pending: {
        type: ACTIONS.GET_INBOX_LIST.PENDING,
    },
    success: (data: InboxList, paginationData: LimitAndSkipData) => ({
        type: ACTIONS.GET_INBOX_LIST.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
        paginationData,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_INBOX_LIST.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const updateInboxStatus = {
    pending: {
        type: ACTIONS.UPDATE_INBOX_STATUS.PENDING,
    },
    success: (id: string) => ({
        type: ACTIONS.UPDATE_INBOX_STATUS.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        payload: {
            id,
        },
    }),
    error: (error: Error) => ({
        type: ACTIONS.UPDATE_INBOX_STATUS.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const updateInboxStatusBegin = (id: string, data: UpdateInboxStatus) => {
    return {
        type: ACTIONS.UPDATE_INBOX_STATUS_BEGIN,
        payload: {
            id,
            data,
        },
    };
};

export const getInboxListCount = {
    pending: (data: LimitAndSkipData) => ({
        type: ACTIONS.SET_INBOX_LIST_COUNT.PENDING,
        data,
        status: FETCH_STATUS.LOADING,
    }),
    success: (inboxCount: InboxCountType) => ({
        type: ACTIONS.SET_INBOX_LIST_COUNT.SUCCESS,
        inboxCount,
        status: FETCH_STATUS.SUCCESS,
    }),
    error: (error: Error) => ({
        type: ACTIONS.SET_INBOX_LIST_COUNT.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const getInboxSearchForm = {
    pending: {
        type: ACTIONS.GET_INBOX_SEARCH_FORM.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (searchForm: Form) => ({
        type: ACTIONS.GET_INBOX_SEARCH_FORM.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data: searchForm,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_INBOX_SEARCH_FORM.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getInboxListBegin = (paginationData: LimitAndSkipData) => {
    return {
        type: ACTIONS.GET_INBOX_LIST_BEGIN,
        status: true,
        paginationData,
    };
};

export const setInboxFilterSelections = (data: Record<string, string | string[]>) => {
    return {
        type: ACTIONS.CHANGE_INBOX_FILTERS,
        payload: { data },
    };
};

export const getInboxSearchConfiguredFormBegin = () => {
    return {
        type: ACTIONS.GET_INBOX_SEARCH_FORM_BEGIN,
    };
};

export const applyInboxFilters = (data: FilterCondition[], paginationData: LimitAndSkipData) => {
    return {
        type: ACTIONS.APPLY_INBOX_FILTERS,
        payload: { data },
        data: paginationData,
    };
};
